var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "cases"
  }, [_c("div", {
    staticClass: "cases-main"
  }, [_c("Title", {
    attrs: {
      title: _vm.title
    }
  }), _c("section", {
    staticClass: "cases-content"
  }, _vm._l(_vm.casesList, function (item) {
    return _c("div", {
      key: item.title,
      staticClass: "item_content",
      style: {
        width: `${_vm.customWidth}px`
      }
    }, [_c("img", {
      staticClass: "img_head",
      attrs: {
        src: item.img_head,
        alt: ""
      }
    }), _c("span", {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _c("img", {
      staticClass: "img_icon",
      attrs: {
        src: item.img_icon,
        alt: ""
      }
    })]);
  }), 0)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };